import { CHANNEL_TYPES } from "models/sale";
// Moved to @rista/core/helpers/saleHelpers — the sale-pricing closure.
export { getBasicSaleData, getSaleDataFromReducer, calculateAndSaveSaleData, calculateSaleDataPrice, calculateCharges, getAmountForCharge, getSaleRecordDataCopy, calculateSale, getParamsForSaleCalculate, getSaleItems, getAllDiscounts, removeDiscountFromCart, removeExternalDiscount, shouldRetainBillDiscount, getClonedSaleDataFromReducer, validateManualDiscountLimitFn, hasItemLeveErrors, resetCustomer, resetSaleData } from "@rista/core/helpers/saleHelpers";
// IMPORTED as well as re-exported — this file's own body still calls these
// (ledger rule 5: a re-export creates no local binding).
import { calculateAndSaveSaleData, calculateSaleDataPrice, calculateCharges, getParamsForSaleCalculate, shouldRetainBillDiscount, getClonedSaleDataFromReducer } from "@rista/core/helpers/saleHelpers";
import moment from "moment";
import { tz } from 'moment-timezone';
import { resetCustomerStore } from "redux-store/slices/CustomerSlice";
import { addDiscountApprovalData, applyDiscountSuccess } from "redux-store/slices/DiscountSlice";
import { saveSaleData } from "redux-store/slices/SaleSlice";
import { updateCurrentTableInfo } from "redux-store/slices/TableViewSlice";
import store from "../redux-store/index";
import { getItemPrice } from "./catalogueHelpers";
import { removeLocalStorage } from "utils";
import { getBranchId } from "./commonHelpers";
import { isAdvanceOrder } from "./myOrderHelpers";
import { printItemLabelTemplate, printSale, printSaleTickets } from "./printHelper";
import { fetchOrderData, getOverviewOrderData } from "redux-store/slices/MyOrderSlice";
import { DISCOUNT_MODES, DISCOUNT_TYPES, METHODS, PAYMENT_DEF_DATA_TYPE } from "data/constants";
import { ENDPOINT } from "config/endpoints";
import { fetchCommonData } from "redux-store/slices/common";
import { ACCEPTED, CLOSED, CREATE_TICKETS, CREATE_TICKET_ON_SAVE, DELIVERY, FULFILLMENT_STATUS_TYPES, LOCALSTORAGE_KEYS, NEW, OVERVIEW, SAVE } from "utils/constants";
import { fetchMyOrderDataFn, myOrderSaveSaleFn } from "facade/ServiceFacade";
import { ToastNotifyError, ToastNotifySuccess } from "commonComponents/ToastNotify";
import { getSendData } from "./myOrderHelpers";
import { refreshOrdersList } from "@rista/core/myOrders/refresh";
import { getNewOrderData } from "redux-store/slices/MyOrderSlice";
import { featureRestrictions } from "./featureRestrictionHelper";
import { EDIT_CUSTOMER_AFTER_BILL_PRINT, EDIT_ORDER_AFTER_BILL_PRINT, SAVE_ORDER } from "utils/restrictionConstants";
import { hideCloseOptionForDiscountApproval } from "./hideCloseOptionForDiscountApproval";
import { getAllNewOnlineOrders } from "redux-store/slices/NotificationsSlice";
import { SaleDataType } from "models/sale";
import { businessHelpers, loyaltyHelpers } from "@dotpe/rista-pos-common";
// The auto-print decision lives in @rista/core/itemLabelSettings, shared with apps/mobile's
// copy of `printItemLabelStickerOnOrderAccept`. This file used to import `PrintStage` and spell
// the comparison out; the predicate owns it now, so the enum is no longer referenced here.
//
// ⚠️ Deep-imports `/rules`, NOT the package barrel. This file is in the MAIN bundle while the
// settings screen is lazily loaded, and the barrel re-exports the whole domain — registry,
// view model and the controller hook. `packages/core` declares no `sideEffects: false`, so
// webpack cannot tree-shake those back out: pulling one symbol off the barrel measurably moved
// the entire flow into main.js (verified in a production build). `/rules` is pure and imports
// only `/model`, the inert vocabulary layer — no React, no redux.
import { shouldPrintLabelsOnAccept } from "@rista/core/itemLabelSettings/rules";
import { checkAndUpdateApprovalState } from "./updateDiscountApprovalState";
import { SaleItem } from "models/saleItem";
import { unBlockExternalDiscount } from "redux-store/slices/Loyalty";
import { getActiveProvider, isCustomerLockedByLoyalty } from "helper/loyaltyHelper";
import { SALE_SOURCE_TYPES } from "../data/constants";
import { isExternalLoyaltyProvider, isExternalProviderC1, isLoyaltyPointDiscountType } from "./loyaltyHelper";


export function prepareSimpleItem(itemData: any, saleData: any, itemQnty: any) {
  const branchId = getBranchId();
  const scheduleData = store.getState().catalogStore?.scheduleData;
  let saleDataStore = store.getState().saleDataStore,
    selectedChannelData = saleDataStore?.selectedChannelData,
    itemPrice: number = getItemPrice(itemData, {
      channelData: selectedChannelData,
      branchTimeZoneId: store.getState().businessStore?.businessData?.timeZone?.zoneId,
      branchId,
      itemSchedules: scheduleData,
    }) || 0;
  return ({
    "itemId": itemData.mid,
    "shortName": itemData.info?.shortName,
    "longName": itemData.info?.longName,
    "skuCode": itemData.info?.skuCode,
    "categoryId": itemData.info?.categoryId,
    "subCategoryId": itemData.info?.subCategoryId,
    "categoryGroupId": itemData.info?.categoryGroupId,
    "note": "",
    "quantity": itemQnty ? itemQnty : 1,
    "channelId": saleData?.channelId || "",
    "channelDefId": saleDataStore?.selectedChannelData?.channelDefId,
    "channelName": saleDataStore?.selectedChannelData?.name,
    "unitPrice": itemPrice,
    "measuringUnit": itemData.info?.measuringUnit || "",
    "itemPriceTotal": (itemPrice * 1),
    "itemOptionTotal": 0,
    "itemDiscountTotal": 0,
    "itemSubTotal": 0,
    "itemOptionList": [],
    "isPriceIncludesTax": itemData?.priceInfo?.isPriceIncludesTax ? itemData?.priceInfo?.isPriceIncludesTax : false,
    "isBackOrder": false,
    "isCombo": itemData?.info?.isCombo ? itemData?.info?.isCombo : false,
    "itemTaxCode": itemData.info?.itemTaxCode || "",
    "itemNature": itemData.info?.itemNature,
    "displayNotes": false,
    "chargeIds": !!itemData.info?.chargeIds?.length ? itemData.info.chargeIds : [],
    "denyDiscount": itemData.priceInfo?.denyDiscount,
    "taxTypeIds": itemData.priceInfo?.taxTypeIds,
    "taxPaidAt": "",
    "isNewItem": itemData?.isNewItem,
    "serviceLabel": saleDataStore?.saleData?.serviceLabel || {},
    "itemDiscountList": saleDataStore?.itemDiscountList || [],
    "billDiscountList": saleDataStore?.billDiscountList || [],
    "createTickets": saleDataStore?.createTickets || false,
    "recommendationInfo": itemData?.recommendationInfo || undefined,
    "isSearchView": itemData?.isSearchView || undefined
  });
}

export function findItemFromSaleData(saleData: [], itemId: string) {
  let itemIndex = -1;
  if (!!saleData.length) {
    itemIndex = saleData.findIndex((item: any) => item.itemId === itemId);
  }
  return itemIndex;
}

export function updateQuantity(itemData: any, index: number, action: string) {
  let data = [...itemData],
    temp = { ...data[index] };
  if (action === 'increase') {
    temp.quantity++;
  } else {
    if (temp.quantity > 1) {
      temp.quantity--;
    } else if (temp.quantity > 0 && temp.quantity < 1) {
      temp.quantity = 0;
      data.splice(index, 1);
    } else {
      data.splice(index, 1);
      temp.quantity--;
    }
  }
  if (temp.quantity) {
    temp.itemPriceTotal = temp.unitPrice * temp.quantity;
    data[index] = temp;
  }
  return data;
}

export function getUpdatedSaleData(saleData: SaleDataType) {
  let saleDataStore = store.getState().saleDataStore,
    businessData = store.getState().businessStore.businessData,

    currency = saleData?.currency || businessData.currencyCode,
    branchId = saleData?.branchId || businessData.branchId,
    channelId = saleData.channelId || getSelectedChannelId();

  return ({
    ...saleData,
    "mid": saleData.mid,
    "branchId": branchId,
    // TODO(kiosk-channel): make this fallback kiosk-aware once the backend accepts `KIOSK` —
    // `saleData?.channel || (isKioskModeEnabled() ? CHANNEL_TYPES.KIOSK : CHANNEL_TYPES.POS)`.
    // Held back with the stamp in `@rista/core/helpers/saleHelpers`'s `resetSaleData`; see the
    // TODO there for why. An existing channel already wins, so this only ever decides the
    // default for a sale that reaches here without one.
    "channel": saleData?.channel || CHANNEL_TYPES.POS,
    "currency": currency,
    "saleItems": saleData.saleItems,
    "itemCount": saleData.saleItems?.length,
    "saleStatus": "Open",
    "billSubTotal": 0,
    "discountTotal": 0,
    "billTotal": 0,
    "billRoundedAmount": 0,
    "discountList": [],
    "chargeTotal": 0,
    "chargeList": !!saleData.chargeList?.length ? saleData.chargeList : [],
    "transactionType": "Sale",
    "channelId": channelId,
    "channelDefId": saleDataStore?.selectedChannelData?.channelDefId,
    "channelName": saleDataStore?.selectedChannelData?.name,
    "groupId": saleData.groupId,
    "customerInfo": saleData.customerInfo || undefined,
    "createTickets": saleData.createTickets || false,
    "note": saleData.note || "",
    "deliveryInfo": saleData.deliveryInfo || undefined,
    "serviceLabel": saleData.serviceLabel || undefined,
    "createdAt": (saleData.createdAt) || moment().format('DD-MM-YYYY | LTS'),
    "version": saleData.version,
    "updatedBy": saleData.updatedBy || undefined,
    "tickets": saleData.tickets || [],
    "modifiedBy": saleData.modifiedBy || undefined,
    "billHeader": saleData.billHeader || undefined,
    "billNumbers": saleData.billNumbers || [],
    "billNumber": saleData.billNumber,
    "lastItemNumber": saleData.lastItemNumber,
    "lastTicketNumber": saleData.lastTicketNumber,
    "billTaxList": saleData.billTaxList || {},
    "itemDiscountList": saleData.itemDiscountList || [],
    "billDiscountList": saleData.billDiscountList || [],
    "saleBy": saleData.saleBy || undefined,
  })
}

export function updateSaleData(itemData: any, action: string, itemIndex: number = 0, isCart: boolean = false, itemQnty: any = 1) {
  let currentData = getClonedSaleDataFromReducer() || {};
  if (!isCart) {
    if (itemData.type === "Group" && currentData?.saleItems?.length) {
      for (let item = currentData?.saleItems?.length - 1; item >= 0; item--) {
        if (currentData.saleItems[item]?.variantValues?.[0]?.parentItemId === itemData.mid) {
          itemIndex = item;
          break;
        }
      }
    } else {
      itemIndex = currentData?.saleItems?.findIndex((item: any) => item.itemId === itemData.mid);
    }
  } else {
    itemIndex = currentData?.saleItems?.length - 1 - itemIndex;
  }
  let businessData = store.getState().businessStore.businessData,
    currency = currentData?.currency || businessData.currencyCode,
    branchId = currentData?.branchId || businessData.branchId,
    channelId = currentData.channelId || getSelectedChannelId();
  if (!currentData.currency) currentData.currency = currency;
  if (!currentData.branchId) currentData.branchId = branchId;
  if (!currentData.channelD) currentData.channelId = channelId;

  switch (action) {
    case 'add':
      if (itemIndex > -1 && isCart) {
        currentData.saleItems = updateQuantity(currentData.saleItems, itemIndex, 'increase');
      }
      else {
        // if (itemIndex === -1) {
        let item = prepareSimpleItem(itemData, currentData, itemQnty);
        currentData.saleItems = [...(currentData?.saleItems || []), ...[item]];
        // } else {
        //   currentData.saleItems = updateQuantity(currentData.saleItems, itemIndex, 'increase');
        // }
      }
      currentData = getUpdatedSaleData(currentData);
      return currentData;
    case 'subtract':
      if (itemIndex > -1)
        currentData.saleItems = updateQuantity(currentData.saleItems, itemIndex, 'decrease');
      return currentData;
    case 'delete':
      if (itemIndex > -1) {
        currentData.saleItems.splice(itemIndex, 1);
      }
      return currentData;
  }
}


export function roundOffBillAmount(payment: PAYMENT_DEF_DATA_TYPE, enteredAmount: string | number, paymentInfo?: any) {
  let windowObj: any = window;
  const businessStore = store.getState().businessStore;
  const roundOnlyCashPaymentMode = businessStore?.businessData?.enableRoundingCashOnly;
  const billRoundingMode = businessStore?.businessData?.roundingMode;
  const params = { roundOnlyCashPaymentMode, billRoundingMode };
  let amount: any = enteredAmount;
  if (windowObj.RL?.saleutil?.roundOffBillAmountBasedOnPaymentModes) {
    amount = windowObj.RL.saleutil.roundOffBillAmountBasedOnPaymentModes(payment, params, enteredAmount, paymentInfo);
  }
  return parseFloat(amount);
}


// moved to @rista/core/helpers/saleHelpers (2026-09-29, My Orders v2's sale return and its charges editor; web's bodies). Re-export only.
export { getApplicableCharges, getParamsForEditSaleCalculate, handleLocalCharges } from "@rista/core/helpers/saleHelpers";


/**
 * Clears the customer and delivery info from a **surviving** sale, dropping the customer's loyalty
 * deals, then recalculates and saves.
 *
 * No-ops while loyalty points or a partner coupon are applied: those are blocked against the
 * customer on the backend and must be released first. Deliberate removals are already stopped at
 * the UI with `CUSTOMER_EDIT_INFO_FOR_LOYALTY`; this catches the callers that clear the customer
 * implicitly, such as the customer modal's reset on mount and on offline toggle.
 *
 * Not for sale teardown — that replaces the sale object rather than clearing a field, and its
 * refund is owned by `resetSaleEffect`. See `docs/flows/LOYALTY_REFUND.md`.
 */
export function clearCustomerInfoAndSave(saleData: SaleDataType) {
  if (isCustomerLockedByLoyalty(saleData)) return;
  const discountData = store.getState()?.catalogStore?.discounts || {};
  const updatedSaleData = { ...saleData, discountList: loyaltyHelpers.filterLoyaltyDeals(discountData, saleData) };
  //remove deals with loyalty , if added for customer
  calculateAndSaveSaleData({ ...updatedSaleData, deliveryInfo: {}, customerInfo: {} });
}


/**
 * Whether a bill discount survives recalculation. Identifiable entries are kept, transient
 * scratch state from an in-progress edit is dropped:
 *
 * - `discountId` — catalog discount or deal.
 * - `mid` — coupon / external-partner discount; these have no `discountId`.
 * - loyalty points — have neither id, and must stay on the bill until their refund succeeds
 *   (`docs/flows/LOYALTY_REFUND.md`).
 *
 * Shared by `calculateAndSaveSaleData` and `getCalculatedSale`. **Reuse it for any new retention
 * filter** — two divergent inline literals previously stripped applied loyalty points mid-edit.
 */


export function getCalculatedSale(currentSale: any, prevSale: any) {
  let saleData = structuredClone(currentSale), params = getParamsForSaleCalculate(saleData);
  let filteredDiscount = saleData?.billDiscountList?.filter(shouldRetainBillDiscount);
  saleData = { ...saleData, billDiscountList: filteredDiscount };
  saleData = calculateCharges(saleData);
  let sale = calculateSaleDataPrice(saleData, params);
  if (Math.abs(sale?.discountTotal || 0) < Math.abs(prevSale?.discountTotal || 0)) { //check if any discount got removed
    checkAndUpdateApprovalState(sale);
  }
  return sale;
}

export function updateChannelDataInSale(channelDefId: string = '') {
  if (channelDefId) {
    let saleData = getClonedSaleDataFromReducer(),
      channelVos = !!store.getState()?.catalogStore?.channelvos
        ? store.getState().catalogStore.channelvos
        : [],
      index =
        channelVos.length &&
        channelVos.findIndex(
          (channelData: any) => channelData.channelDefId === channelDefId,
        );
    if (
      saleData &&
      saleData['serviceLabel'] &&
      Object.keys(saleData['serviceLabel']).length
    ) {
      saleData['serviceLabel'] = {};
      saleData['customerInfo'] = {};
    }
    if (index > -1) {
      saleData['channelId'] = channelVos?.[index]?.channelId;
      saleData['channelDefId'] = channelVos?.[index]?.channelDefId;
      saleData['groupId'] = channelVos?.[index]?.groupId;
      saleData['channelName'] = channelVos?.[index]?.name;
    }
    saleData.saleItems = [];
    saleData.deliveryInfo = {};
    calculateAndSaveSaleData(saleData);
    // store.dispatch(saveSaleData(saleData));
  }
}

export function getApplicableDeals() {
  try {
    let windowObj: any = window;
    const businessData = store.getState()?.businessStore?.businessData,
      selectedChannelData =
        store.getState()?.saleDataStore?.selectedChannelData,
      membershipId = (
        store.getState()?.saleDataStore.saleData?.customerInfo || {}
      ).membershipId,
      discountList = store.getState().catalogStore?.discounts;
    const filteredDiscounts =
      Object.keys(discountList)?.length > 0 &&
      Object.keys(discountList)
        .filter((key) => discountList[key]?.dclass === "Deal")
        .reduce((result: any, key) => {
          const isValidDiscountResult: any =
            windowObj.RL?.dealutil.isValidDiscount({
              discount: discountList[key],
              branchTime: tz(businessData?.timeZone?.zoneId).format(),
              transactionEnd: businessData?.transactionEnd,
              membershipId: membershipId,
              channelDefId: selectedChannelData?.channelDefId,
            });
          if (isValidDiscountResult) {
            result[key] = discountList[key];
          }
          return result;
        }, {});
    return filteredDiscounts;
  } catch (error) {
    return [];
  }
}

// Moved to @rista/core/helpers/saleHelpers (shared.ts — ONE body for both apps). The only
// difference between the two app copies was how they reached `dealutil`: `window.RL.dealutil`
// here, `globalThis.dealutil` on mobile. Core imports the module instead, so the bodies are
// identical and there is nothing left to split.
export { getCurrentDeals, getCurrentDealsForSale } from "@rista/core/helpers/saleHelpers";

export function getCartVisibleDiscounts() {
  try {
    let catalogStore = store.getState().catalogStore,
      saleData = store.getState().saleDataStore?.saleData,
      businessData = store.getState().businessStore?.businessData,
      discountList = catalogStore?.discounts ? Object.values(catalogStore.discounts) : [],
      cartVisibleDiscounts = discountList.filter((discount: any) => discount?.enableVisibilityOnCart),
      windowObj: any = window;
    if (!cartVisibleDiscounts?.length) return [];
    return windowObj.RL.dealutil.getCurrentDealsForSale({
      discounts: cartVisibleDiscounts,
      branchTime: moment().tz(businessData?.timeZone?.zoneId || "Asia/Calcutta").format(),
      sale: saleData, transactionEnd: businessData.transactionEnd
    });
  } catch (error) {
    return [];
  }
}

// moved to core 2026-09-29 (My Orders v2's detail asks it itself); re-exported for this app's importers
export { isDiscCustAuthReq } from '@rista/core/helpers/saleHelpers';

export function isVerificationRequired() {
  const businessData = store.getState().businessStore?.businessData;
  if (!businessHelpers.isAuthenticationEnabled(businessData)) return false;
  let orderData = store.getState().myOrderStore?.currentOrderData;
  return (
    orderData?.billDiscountList?.length > 0 &&
    orderData?.billDiscountList?.some(
      (discount: any) => discount?.authenticateCustomer === true
    )
  );
}

// The customer-authentication OTP trio now lives in @rista/core — one definition, no drift.
// Re-export only: nothing in this file calls them.
export {
  fetchCustomerOtpHash,
  removeDiscountFromSale,
  verifyOtpHash,
} from "@rista/core/helpers/saleHelpers";


export function getParsedChargeData(selectedCharge: any = {}) {
  let chargeData: any = {};
  chargeData["chargeType"] = selectedCharge.chargeType;
  chargeData["chargeRate"] = selectedCharge.chargeRate;
  chargeData["name"] = selectedCharge.name;
  chargeData["chargeId"] = selectedCharge.mid;
  chargeData["isIncludesTax"] = selectedCharge.isIncludesTax;
  chargeData["isDirectCharge"] = selectedCharge.isDirectCharge;
  chargeData["categoryIds"] = selectedCharge.categoryIds;
  chargeData["label"] = selectedCharge.label;
  return chargeData;
}

;


export function saveChannleDataInSale(channelDefId: string = "") {
  if (channelDefId) {
    let saleData = getClonedSaleDataFromReducer(),
      channelVos = !!store.getState()?.catalogStore?.channelvos ? store.getState().catalogStore.channelvos : [],
      index = channelVos.length && channelVos.findIndex((channelData: any) => channelData.channelDefId === channelDefId);
    if (index > -1) {
      saleData["channelId"] = channelVos?.[index]?.channelId;
      saleData["channelDefId"] = channelVos?.[index]?.channelDefId;
      saleData["groupId"] = channelVos?.[index]?.groupId;
    }
    store.dispatch(saveSaleData(saleData));
  }
}


export function resetSaleItems() {
  let saleData = getClonedSaleDataFromReducer();
  saleData.saleItems = [];
  saleData.deliveryInfo = {};
  saleData.discountList = [];
  saleData.billDiscountList = [];
  store.dispatch(addDiscountApprovalData({
    mid: saleData.mid,
    isApprovalRequired: false,
    isRequested: false,
    isApproved: false,
    totalDiscount: 0,
  }));
  store.dispatch(saveSaleData(saleData));
}

// Moved to @rista/core/helpers/saleHelpers with the feature gate's payment-mode filter. IMPORTED as
// well as re-exported — this file calls it in its own body just below (ledger rule 5).
export { getSelectedChannel } from "@rista/core/helpers/saleHelpers";
import { getSelectedChannel } from "@rista/core/helpers/saleHelpers";

export function getItemLevelDiscount(categoryId: string = "") {
  let discounts = store.getState()?.catalogStore?.discounts ? store.getState()?.catalogStore?.discounts : [];
}

export function getSelectedChannelId() {
  let selectedChannelData = getSelectedChannel(), result = "";
  if (selectedChannelData.channelDefId) {
    let channelVos = !!store.getState()?.catalogStore?.channelvos ? store.getState().catalogStore.channelvos : [];
    if (channelVos.length) {
      channelVos.forEach((chanelVo: any) => {
        if (chanelVo.channelDefId === selectedChannelData.channelDefId) {
          result = chanelVo.channelId;
        }
      });
    }
  }
  return result;
}

export function getItemDiscount(categoryId: string = "") {
  let result: any = [];
  let discounts = store.getState().catalogStore?.discounts ? store.getState().catalogStore.discounts : {};
  if (discounts && !!Object.keys(discounts).length) {
    let discountData = Object.values(discounts);
    if (discountData.length) {
      discountData.forEach((discount: any) => {
        if (discount.dclass === "Discount" && (discount.categoryIds?.length ? discount.categoryIds.includes(categoryId) : true)) {
          result.push(discount);
        }
      });
    }
  }
  return result;
}

export function checkForEventPresent(data: any = {}) {
  if (data?.eventLog?.length === 2)
    return true;
  return false;
}


/**
 * same as checkCreateTicket but we send in sale data as param
 * @param opType
 * @param saleData
 * @returns
 */
export function checkCreateTicketForOnlineOrder(opType = CREATE_TICKET_ON_SAVE, saleData: SaleDataType) {
  let windowObj: any = window,
    posSettings = !!store.getState()?.catalogStore?.posSettings ? store.getState().catalogStore.posSettings : {};
  let channelDef = getChannelDef(saleData.channelDefId);
  if (isAdvanceOrder(saleData) && channelDef?.delayAdvanceOrderTicketCreation)
    return false; // do not create ticket in case of advance order
  if (saleData?.serviceLabel?.isAdhoc && channelDef.skipAdhocTicketCreation) return false;
  let result = windowObj.RL.saleutil.checkTicketCreation({
    sale: saleData,
    posPreferences: posSettings,
    posSettings: posSettings, opType: opType,
    channelDef
  });
  return result;
}


export function getChannelVos(id: string = "") {
  let result: any = {},
    channelVos = !!store.getState().catalogStore?.channelvos?.length ? store.getState().catalogStore.channelvos : [];
  if (id) {
    let index = channelVos.findIndex((channel: any) => channel.channelDefId === id);
    if (index > -1)
      result = { ...channelVos[index] };
  }
  return result;
}

export { getBillHtml } from "@rista/core/helpers/saleHelpers"; // moved to core 2026-09-16 (view-bill sheet)

export function formatNumber(num: any) {
  const decimalPlaces = num?.toString()?.split('.')[1]; // get the number of decimal places

  if (decimalPlaces === undefined) {
    return num;
  } else if (decimalPlaces.length <= 3 && num?.toFixed) {
    return (num?.toFixed ? parseFloat(num?.toFixed(decimalPlaces.length)) : num);
  } else {
    return (num?.toFixed ? parseFloat(num?.toFixed(3)) : num);
  }
}

export function isFractionEditEnable(fractionAllowedUnits: any = [], itemUnit: any) {
  if (fractionAllowedUnits && fractionAllowedUnits?.includes(itemUnit)) {
    return true;
  } else {
    return false;
  }
}


export function calculateAndUpdateSale(sale: any) {
  sale = calculateSaleDataPrice(structuredClone(sale))
  sale = updateSaleMetaInfo(sale);
  return sale;
}
export function hasAnyItemOnHold(items: any = []) {
  let flag = false;
  for (let i = 0; i < items?.length; i++) {
    if (!!items?.[i]?.onHold) {
      flag = true;
      break;
    }
  }
  return flag;
}


export function getSaleVo(sale: any) {
  let windowObj: any = window;
  var saleVoData = windowObj.RL.saleutil.convertSaleToVO(sale);
  saleVoData.offlineNumber = sale.offlineNumber;
  saleVoData.operation = sale.operation;
  saleVoData.syncStatus = sale.syncStatus;
  saleVoData.syncErrorCode = sale.syncErrorCode;
  saleVoData.version = sale.version;
  return saleVoData;
}

export function isRequiredInfoAdded(saleData: any) {
  return (
    saleData?.serviceLabel && Object.keys(saleData?.serviceLabel)?.length ||
    saleData?.deliveryInfo && Object.keys(saleData?.deliveryInfo)?.length ||
    saleData?.customerInfo && Object.keys(saleData?.customerInfo)?.length
  );
}

/**
 *
 * @param saleId
 * create KOT using saleId and print tickets
 */
// Moved to @rista/core/helpers/saleHelpers (2026-09-15, my-orders v2 action layer). Re-export only.
export { handleCreateKOT } from "@rista/core/helpers/saleHelpers";
export function acceptOnlineOrder(
  saleId: any,
  orderSave: boolean = false,
  cb: any = null,
  showSuccessToast: boolean = true
) {
  let payload = {
    saleId: saleId,
    callback: function (responseFromApi: any = {}) {
      const response = structuredClone(responseFromApi)
      const fetchSaveCallback = (saveSaleResponse: any = {}) => {
        store.dispatch(getAllNewOnlineOrders({}));
        if (!saveSaleResponse?.code) {
          if (saveSaleResponse.fulfillmentStatus === ACCEPTED) {
            printSaleTickets(saveSaleResponse, saveSaleResponse?.tickets, 1);
            if (responseFromApi.fulfillmentStatus === FULFILLMENT_STATUS_TYPES.CREATED) {
              printItemLabelStickerOnOrderAccept(saveSaleResponse);
            }
          }
          if (saveSaleResponse?.saleStatus?.toLowerCase() === CLOSED) {
            printSale(
              saveSaleResponse,
              store.getState().printerStore?.defaultPrinter || {},
              1,
              "",
              true
            );
          }
          cb && cb(saleId);
          let obj: any = getSendData(OVERVIEW, DELIVERY.toLowerCase());
          // v2 owns its reads (D13/D14) — refresh whichever model this terminal is running
          if (!refreshOrdersList(OVERVIEW, DELIVERY.toLowerCase() as any, false))
            store.dispatch(getOverviewOrderData({ data: obj, hideLoader: false }));
          showSuccessToast && ToastNotifySuccess("Order Accepted Successfully");
        } else {
          ToastNotifyError("Something went wrong!");
        }
      };
      if (response && Object.keys(response).length) {
        response[CREATE_TICKETS] = checkCreateTicketForOnlineOrder(CREATE_TICKET_ON_SAVE, response);
        let payload = {
          dataToSend: response,
          callback: fetchSaveCallback,
        };
        if (orderSave) {
          myOrderSaveSaleFn(payload);
        } else {
          fetchSaveCallback();
        }
      }
    },
    doNotSaveSale: true
  };
  if (saleId) fetchMyOrderDataFn(payload);
}

export function removeOverlappingOrders(orders: any) {
  // Sort orders based on saleIds in ascending order
  const sortedOrders = orders
    .slice()
    .sort((a: any, b: any) => a.saleId.localeCompare(b.saleId));
  const result = [];
  let prevSaleId = null;
  for (const order of sortedOrders) {
    if (order.saleId !== prevSaleId) {
      result.push(order);
      prevSaleId = order.saleId;
    }
  }
  return result;
}


export function checkHoldOrder() {
  let saleData = getClonedSaleDataFromReducer();
  return (
    featureRestrictions(SAVE_ORDER) &&
    (saleData?.printCount
      ? featureRestrictions(EDIT_ORDER_AFTER_BILL_PRINT)
      : true)
  );
}

/**
 * `checkAddItem` lived here and is GONE. Its only caller was
 * `components/CustomerSummary/RenderFavItem`, deleted when this app moved onto
 * `@rista/ui/components/CustomerSummary`. The rule it expressed — an unprinted bill takes items,
 * a printed one only from a user permitted to edit after printing — is now
 * `canAddItemsToSale` in `@rista/core/customerSummary/favourites`, where it is unit-tested and
 * answered for both platforms instead of being a prop each host filled in differently.
 */

export function checkEditCustomer() {
  let saleData = getClonedSaleDataFromReducer();
  return saleData?.printCount
    ? featureRestrictions(EDIT_CUSTOMER_AFTER_BILL_PRINT)
    : true;
}

/**
 *
 * @param saleItems
 * @returns updated sale items, with shortName replaced with punchedName ,
 * if present
 */
export function updatePunchedNamePrintContent(saleItems: unknown[]) {
  let newItems: unknown[] = saleItems.map((item: any) => {
    return {
      ...item,
      shortName: item.punchedName || item.shortName,
    };
  });
  return newItems;
}


// Moved to @rista/core/helpers/saleHelpers. `showCloseSaleCta` went with the feature gate, the one
// caller of `isOrderingLicense` in this file, so both are re-exports now (ledger rule 5).
export { isOrderingLicense, showCloseSaleCta } from "@rista/core/helpers/saleHelpers";

/**
 * Auto-print item labels for an online order that has just been accepted.
 *
 * The DECISION is `shouldPrintLabelsOnAccept` in `@rista/core/itemLabelSettings/rules`, shared
 * with apps/mobile's copy of this function. Only the print stays here: core cannot import
 * `helper/printHelper`, which pulls in `html-to-image`, `jsbarcode` and the poller.
 *
 * The `!isEmpty(saleData)` / `!isEmpty(itemLabelSettings)` pre-checks this used to carry are
 * subsumed by the predicate — it needs a `channelDefId` on the sale and a non-empty
 * `channelDefIds` on the settings before it can return true.
 */
export function printItemLabelStickerOnOrderAccept(saleData: any) {
  const itemLabelSettings =
    store.getState()?.catalogStore?.posSettings?.itemLabelSettings || {};
  if (shouldPrintLabelsOnAccept(itemLabelSettings, saleData)) {
    printItemLabelTemplate(saleData, itemLabelSettings);
  }
}


/**
 * Retrieves the loyalty provider ID based on current channel and branch selection.
 * @returns The ID of the current loyalty provider, or undefined if not available.
 */
export function getCurrentLoyaltyProviderId() {
  const externalProviderData = getActiveProvider();
  return externalProviderData?.mid;
}

/**
 * Extracts the unique set of `itemId`s from a given cart.
 *
 * @param saleItems - The list of cart items.
 * @returns A Set containing unique `itemId`s from the cart.
 *
 */
// Moved to @rista/core/helpers/saleHelpers (shared.ts — both apps had the same function; this
// platform's defensive body won). Re-exported so this file's importers are unchanged.
export { getUniqueCartItemIds } from "@rista/core/helpers/saleHelpers";

/**
 * Summarizes sale data into counts and totals of recommended vs catalog items.
 *
 * @param saleData - The sale data object containing items and bill total
 * @returns Summary with counts, totals, and overall bill information
 */
// Moved to @rista/core/helpers/saleHelpers — re-exported so this file's importers are
// unchanged. The toast it shows is the injected `notifyError` (core cannot import UI).
export { showToastFromApi } from "@rista/core/helpers/saleHelpers";

// Moved to @rista/core/helpers/saleHelpers.
//   isLastKOT         -> shared.ts (byte-identical in both apps modulo quote style)
//   summarizeSaleData -> each variant: this platform's return shape differs from the other's,
//                        so a shared body would change one platform's analytics payload.
export { isLastKOT, summarizeSaleData } from "@rista/core/helpers/saleHelpers";

// Moved to @rista/core/helpers/saleHelpers. `updateSaleMetaInfo` and `getChannelDef` are in
// shared.ts; `populateMetaInfo` and `checkCreateTicket` are per-variant (this platform reaches
// the rista-library global its own way and clones differently). All four are IMPORTED as well
// as re-exported: this file calls each of them in its own body (hazard 30).
export {
  populateMetaInfo,
  checkCreateTicket,
  updateSaleMetaInfo,
  getChannelDef,
} from "@rista/core/helpers/saleHelpers";
import {
  updateSaleMetaInfo,
  getChannelDef,
} from "@rista/core/helpers/saleHelpers";

